import { useSelector } from 'react-redux';

import { selectLoggedInAccount } from '../../store/selectors/account.selectors';

/**
 * @returns the user's logged in / jumped-into account.
 */
export const useAccount = () => {
  const account = useSelector(selectLoggedInAccount);
  return account;
};
